import { ConfigurationTransferEditForm } from "src/app/features/ConfigurationTransfer/components/forms/ConfigurationTransferEditForm";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";

export const ConfigurationTransferEditFormPage = () => {
    const hasAccess = canAccess(ResourceName.CONFIGURATION_TRANSFER, "canRead");

    return (
        <FPage>
            {hasAccess ? (
                <>
                    <FPageHeader>
                        <PageTitle translationKey="page.title.configurationTransferPage" />
                    </FPageHeader>
                    <FPageContent>
                        <ConfigurationTransferEditForm />
                    </FPageContent>
                </>
            ) : (
                <NoAccessLayout />
            )}
        </FPage>
    );
};
